.socialButton.socialButton {
  width: 100%;
}
